import authorReviewFormsReviewFormTemplate from 'controllers/author/evaluationForms/view/template.html';

const usersEventsState = {
  url: '/events',
  stateName: 'Events',
  data: {
    specialClass: 'fixed-sidebar'
  },
  abstract: true
};

const usersEventsEventState = {
  url: '/:eventId',
  stateName: 'Event',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/events/:id'),
  },
  abstract: true
};

const usersEventsEventReviewState = {
  url: '/review',
  stateName: 'Event Review',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: authorReviewFormsReviewFormTemplate,
      controller: 'AuthorEvaluationFormsEvaluationFormController'
    }
  }
};

export { usersEventsState, usersEventsEventState, usersEventsEventReviewState };



// WEBPACK FOOTER //
// ./src/app/controllers/users/events/index.js